var _path, _path2, _path3, _path4, _path5, _path6, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBySideLightActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 54,
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5C3.5 4.17157 4.17157 3.5 5 3.5H47.5V50.5H5C4.17157 50.5 3.5 49.8284 3.5 49V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.5C27.6406 27.5 29 26.1641 29 24.5C29 22.8594 27.6406 21.5 26 21.5C24.3359 21.5 23 22.8594 23 24.5C23 26.1641 24.3359 27.5 26 27.5ZM28.0859 28.25H27.6875C27.1719 28.5078 26.6094 28.625 26 28.625C25.3906 28.625 24.8047 28.5078 24.2891 28.25H23.8906C22.1562 28.25 20.75 29.6797 20.75 31.4141V32.375C20.75 33.0078 21.2422 33.5 21.875 33.5H30.125C30.7344 33.5 31.25 33.0078 31.25 32.375V31.4141C31.25 29.6797 29.8203 28.25 28.0859 28.25Z",
    fill: "#6E7391"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5C3.5 4.17157 4.17157 3.5 5 3.5H47.5V50.5H5C4.17157 50.5 3.5 49.8284 3.5 49V5Z",
    stroke: "#5C617C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 3.5H91C91.8284 3.5 92.5 4.17157 92.5 5V49C92.5 49.8284 91.8284 50.5 91 50.5H48.5V3.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27.5C72.6406 27.5 74 26.1641 74 24.5C74 22.8594 72.6406 21.5 71 21.5C69.3359 21.5 68 22.8594 68 24.5C68 26.1641 69.3359 27.5 71 27.5ZM73.0859 28.25H72.6875C72.1719 28.5078 71.6094 28.625 71 28.625C70.3906 28.625 69.8047 28.5078 69.2891 28.25H68.8906C67.1562 28.25 65.75 29.6797 65.75 31.4141V32.375C65.75 33.0078 66.2422 33.5 66.875 33.5H75.125C75.7344 33.5 76.25 33.0078 76.25 32.375V31.4141C76.25 29.6797 74.8203 28.25 73.0859 28.25Z",
    fill: "#6E7391"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 3.5H91C91.8284 3.5 92.5 4.17157 92.5 5V49C92.5 49.8284 91.8284 50.5 91 50.5H48.5V3.5Z",
    stroke: "#5C617C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 53,
    stroke: "#5C617C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBySideLightActive);
export default __webpack_public_path__ + "static/media/side-by-side-light-active.60d0d41c2.svg";
export { ForwardRef as ReactComponent };